

























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Empty from "@/components/empty.vue";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
import LeaveConfirm from "@/components/dialogs/leaveConfirmDialog.vue";
import {
  GetMulu,
  EditChapter,
  GetChapter,
  DelChapter,
  MoveChapter,
} from "@/request/common";
import Resources from "../components/resources.vue";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
@Component({
  components: {
    Empty,
    DsEditor,
    LeaveConfirm,
    Resources,
  },
})
export default class Name extends Vue {
  private type: any = "";
  private ifCompose: any = false;
  private saveConfirmType: any = "";
  private ifShowSaveConfirm: boolean = false;
  private noSaveText: any = "不保存，切换";
  private target: any = {};
  private detail: any = {};
  private ifModify: any = false;
  private modifyData: any = {};
  private clickData: any = {}; // 点击的数据
  private addJiegouData: any = {};
  private ifShowAdd: any = false;
  private data: any = [];
  private expandedNode: any = [];
  private currentNode: any = {};
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private changeType(e: any) {
    this.type = e;
  }
  private changeZhishidian(e: any) {
    this.currentNode = e;
    this.init();
    this.getDetail();
  }
  private cancel() {
    this.ifShowSaveConfirm = false;
    this.init();
  }
  private defaultProps: any = {
    label: "名称",
  };
  private save(cancelGetdetail?: any) {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      EditChapter(this, this.detail, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success(
            this.addJiegouData.chapter_id ? "编辑成功" : "创建成功"
          );
          this.ifCompose = false;
          if (!cancelGetdetail) {
            this.getDetail();
          }
          resolve(res);
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private editorChange(e: any) {
    this.detail.content = e;
  }
  private append(data: any) {
    this.clickData = data;
    this.ifShowAdd = true;
    this.addJiegouData = {
      parent_id: data.chapter_id,
    };
  }
  private openAdd(item?: any) {
    if (item) {
      this.addJiegouData = JSON.parse(JSON.stringify(item));
    } else {
      this.clickData = {};
      this.addJiegouData = {};
    }
    this.ifShowAdd = true;
  }
  private addSure() {
    if (!this.addJiegouData["名称"]) {
      this.$message.warning("请输入名称！");
      return;
    }

    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    EditChapter(this, this.addJiegouData)
      .then((res: any) => {
        loading.close();
        this.$message.success(
          this.addJiegouData.chapter_id ? "编辑成功" : "创建成功"
        );
        this.getData();
        this.ifShowAdd = false;
      })
      .catch(() => {
        loading.close();
      });
  }
  private handleNodeClick(data: any, node: any) {
    if (this.ifCompose) {
      this.target = data;
      this.saveConfirmType = "切换";
      this.noSaveText = "不保存，切换";
      this.ifShowSaveConfirm = true;
    } else {
      this.type = this.systemInfo.SETTING.guanlianziyuan[0];
      this.currentNode = data;
      this.getDetail();
    }
  }
  // 拖拽成功完成时触发的事件
  private handleDrop(draggingNode: any, dropNode: any, dropType: any, ev: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      chapters: this.data,
    };
    MoveChapter(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("移动成功！");
        this.getData().then((d: any) => {
          this.currentNode = draggingNode.data;
          this.init();
        });
      })
      .catch(() => {
        loading.close();
      });
  }
  private handleCommand(e: any) {
    this.clickData = e.data;
    if (e.command == "重命名") {
      this.openAdd(this.clickData);
    } else if (e.command == "删除") {
      this.$confirm(
        "您确定要删除该目录么？删除后该目录下的子结构也将全部删除。",
        "删除",
        {
          customClass: "commonConfirm",
          confirmButtonClass: "iconfont icon-anniu4 confirmSure",
          cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
        }
      )
        .then(() => {
          const params: any = {
            data: {
              chapter_id: this.clickData.chapter_id,
            },
          };
          const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
          });
          DelChapter(this, params, loading).then((res: any) => {
            loading.close();
            this.$message.success("删除成功！");
            this.currentNode = {};
            this.getData().then((d: any) => {
              this.getDetail();
            });
          });
        })
        .catch(() => {
          console.log("取消");
        });
    }
  }
  private init() {
    console.log("初始化");
    if (this.$refs.tree) {
      setTimeout(() => {
        (this.$refs.tree as any).setCurrentKey(this.currentNode);
      }, 100);
      console.log(88888);
      console.log(this.currentNode["chapter_id"]);
      this.expandedNode = [this.currentNode["chapter_id"]];
    }
  }
  private getData() {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      GetMulu(this, {}, loading)
        .then((res: any) => {
          loading.close();
          this.data = res;

          if (this.data.length > 0 && !this.currentNode.chapter_id) {
            this.currentNode = this.data[0];
            this.getDetail();
            setTimeout(() => {
              this.init();
            }, 100);
          } else {
            this.init();
            this.getDetail();
          }
          resolve(res);
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private getDetail() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        chapter_id: this.currentNode.chapter_id,
      },
    };
    GetChapter(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.detail = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  // 保存确认弹框保存
  private changeSave() {
    this.ifShowSaveConfirm = false;
    if (this.saveConfirmType === "切换") {
      this.save(true).then(() => {
        this.currentNode = JSON.parse(JSON.stringify(this.target));
        this.ifCompose = false;
        this.getDetail();
      });
    } else if (this.saveConfirmType === "离开") {
      this.save().then(() => {
        this.$router.back();
      });
    }
  }
  // 保存确认弹框不保存,切换
  private changeConfirmed() {
    this.ifShowSaveConfirm = false;
    if (this.saveConfirmType === "切换") {
      this.currentNode = JSON.parse(JSON.stringify(this.target));
      this.ifCompose = false;
      this.getDetail();
    } else if (this.saveConfirmType === "离开") {
      this.ifCompose = false;
      this.$router.back();
    }
  }
  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to: any, from: any, next: any) {
    if (this.ifCompose) {
      this.saveConfirmType = "离开";
      this.noSaveText = "不保存，离开";
      this.ifShowSaveConfirm = true;
      next(false);
    } else {
      next(true);
    }
  }
  private mounted() {
    if (this.$route.query.data) {
      console.log(33333);
      this.currentNode = JSON.parse(this.$route.query.data as any);
      this.init();
      this.getData();
    } else {
      this.getData();
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    } else {
      this.type = this.systemInfo.SETTING.guanlianziyuan[0];
    }
  }
}
